import request from '@/libs/request'

//专家 列表
export function expertListApi (data) {
  return request({
    url: `expert/expert`,
    method: 'get',
    params: data
  })
}

//专家 详情
export function expertInfoApi (id) {
  return request({
    url: `expert/expert/` + id,
    method: 'get'
  })
}


//专家 编辑/添加
export function expertSaveApi (data) {
  return request({
    url: `expert/expert`,
    method: 'post',
    data: data
  })
}

//专家 删除
export function expertDelApi (id) {
  return request({
    url: `expert/expert/` + id,
    method: 'delete'
  })
}

//专家 所有数据
export function expertAllApi (data = {}) {
  return request({
    url: `expert/expertApi/all`,
    method: 'get',
    params: data
  })
}

